module.exports = __webpack_public_path__ + "img/img61.dd5362fc.png";